// One row per subcatchment, the name followed by any number of (landuse,
// percent) pairs — percent stored as a plain 0-100 number in the file. A
// subcatchment with more pairs than fit on one line repeats its own name on
// a continuation row.

import { readPairSection, writePairSection } from "./pairSection.ts";

export interface Coverage {
  subcatchment: string;
  landUse: string;
  percent: number;
}

export function readCoverages(
  raw: ReadonlyMap<string, string[][]>,
  warnings?: Set<string>
): Coverage[] {
  return readPairSection(raw, "COVERAGES", "percent", warnings).map((r) => ({
    subcatchment: r.subcatchment,
    landUse: r.category,
    percent: r.value,
  }));
}

export function writeCoverages(
  raw: ReadonlyMap<string, string[][]>,
  coverages: Coverage[]
): Map<string, string[][]> {
  return writePairSection(
    raw,
    "COVERAGES",
    coverages.map((c) => ({ subcatchment: c.subcatchment, category: c.landUse, value: c.percent }))
  );
}

export function coveragesFor(coverages: Coverage[], subcatchment: string): Coverage[] {
  return coverages.filter((c) => c.subcatchment === subcatchment);
}
